import {defineAsyncComponent} from 'vue';

const UnmappedComponent = defineAsyncComponent(() => import('@/components/cms/UnmappedComponent.vue'));

const CmsComponentTypes = Object.freeze({
  PseudoComponent: defineAsyncComponent(() => import('@/components/cms/PseudoComponent.vue')),
  ProductFamilyFeatureComponent: defineAsyncComponent(() =>
    import('@/familyDetailsPage/components/ProductFamilyFeatureComponent.vue')
  ),
  DataDrivenFamilySubFamilyCarouselComponent: defineAsyncComponent(() =>
    import('@/familyDetailsPage/components/DataDrivenFamilySubFamilyCarouselComponent.vue')
  ),
  ProductFamilyModelsCarouselComponent: defineAsyncComponent(() =>
    import('@/familyDetailsPage/components/ProductFamilyModelsCarouselComponent.vue')
  ),
  EditorialCollectionComponent: defineAsyncComponent(() => import('@/components/cms/EditorialCollectionComponent.vue')),
  EditorialComponent: defineAsyncComponent(() => import('@/components/cms/EditorialComponent.vue')),
  TrekParagraphComponent: defineAsyncComponent(() => import('@/components/cms/TrekParagraphComponent.vue')),
  CmsTabContainerComponent: defineAsyncComponent(() => import('@/components/cms/CmsTabContainerComponent.vue')),
  ProductPrimaryFeaturesComponent: defineAsyncComponent(() =>
    import('@/components/tabs/features/ProductPrimaryFeatures.vue')
  ),
  ProductStoryComponent: defineAsyncComponent(() => import('@/components/tabs/overview/ProductStories.vue')),
  ProductReferencesComponent: defineAsyncComponent(() =>
    import('@/familyDetailsPage/components/ProductReferencesComponent.vue')
  ),
  ProductMediaReviewComponent: defineAsyncComponent(() =>
    import('@/components/tabs/overview/ProductMediaReviewComponent.vue')
  ),
  TrekProductSpecificationsComponentBom: defineAsyncComponent(() =>
    import('@/components/tabs/specs/BomSpecsContainer.vue')
  ),
  TrekProductSpecificationComponentBom: defineAsyncComponent(() =>
    import('@/components/tabs/specs/ProductSpecBOM.vue')
  ),
  TrekProductSpecificationsComponent: defineAsyncComponent(() => import('@/components/tabs/specs/SpecsContainer.vue')),
  TrekProductSpecificationComponent: defineAsyncComponent(() => import('@/components/tabs/specs/ProductSpec.vue')),
  SizingComponent: defineAsyncComponent(() => import('@/components/cms/SizingComponent.vue')),
  TrekProductTechContainerComponent: defineAsyncComponent(() =>
    import('@/components/containers/tech-info/TechInfoContainer.vue')
  ),
  ProductReviewsComponent: defineAsyncComponent(() => import('@/components/power-reviews/ProductReviewsComponent.vue')),
  DataDrivenProductOverviewComponent: defineAsyncComponent(() =>
    import('@/components/containers/pdp/overview/bike/BikeOverviewContainer.vue')
  ),
  GeometryComponent: defineAsyncComponent(() => import('@/components/cms/GeometryComponent.vue')),
});

const PseudoComponentTypes = Object.freeze({
  'productFamily/productFamilyMarqueeComponent': defineAsyncComponent(() =>
    import('@/familyDetailsPage/components/ProductFamilyMarqueeComponent.vue')
  ),
  'productFamily/productSelectionComponent': defineAsyncComponent(() =>
    import('@/familyDetailsPage/containers/BuyZoneContainer.vue')
  ),
  'productFamily/productFamilyGalleryComponent': defineAsyncComponent(() =>
    import('@/familyDetailsPage/components/ProductFamilyGalleryComponent.vue')
  ),
  'productFamily/productImagesComponent': defineAsyncComponent(() =>
    import('@/familyDetailsPage/containers/ProductImagesContainer.vue')
  ),
});

const getComponentForType = function (typeCode) {
  return typeof CmsComponentTypes[typeCode] !== 'undefined' ? CmsComponentTypes[typeCode] : UnmappedComponent;
};

const getPseudoComponentForUid = function (uid) {
  return typeof PseudoComponentTypes[uid] !== 'undefined' ? PseudoComponentTypes[uid] : UnmappedComponent;
};

export {getComponentForType, getPseudoComponentForUid};
